import React from 'react';
import classes from './Trustpilot.module.css';
import TrustpilotImg from './Trustpilot.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function Trustpilot() {
  const trustpilotLink = 'https://de.trustpilot.com/review/repair-rebels.com';

  return(
    <div className='container'>
      <div className="row">
        <div className={classes.trustpilotContainer}>
          <a href={trustpilotLink} target="_blank" rel="noopener noreferrer">
            Excellent
            <LazyLoadImage className={classes.image} alt="Trustpilot" src={TrustpilotImg} width={120} height={'auto'} effect="blur" />
          </a>
        </div>
      </div>
    </div>
  )
}
